const Sanscript = require('@indic-transliteration/sanscript');

/**
 * Maps Bhasa language names to Sanscript script names.
 */
const scriptMap = {
    hindi: 'devanagari',
    marathi: 'devanagari',
    bengali: 'bengali'
};

const arabicMapping = {
    'a': 'ا', 'b': 'ب', 't': 'ت', 'th': 'ث', 'j': 'ج', 'h': 'ه', 'kh': 'خ',
    'd': 'د', 'dh': 'ذ', 'r': 'ر', 'z': 'ز', 's': 'س', 'sh': 'ش', 'S': 'ص',
    'D': 'ض', 'T': 'ط', 'Z': 'ظ', '3': 'ع', 'gh': 'غ', 'f': 'ف', 'q': 'ق',
    'k': 'ك', 'l': 'ل', 'm': 'م', 'n': 'ن', 'w': 'و', 'y': 'ي',
    '7': 'ح', '5': 'خ', '9': 'ص', '6': 'ط', '8': 'ق', '2': 'ء'
};

const arabicMultiMapping = {
    'th': 'ث', 'kh': 'خ', 'sh': 'ش', 'gh': 'غ', 'dh': 'ذ'
};

/**
 * Transliterates a word from ITRANS (Latin) or Arabizi to the target language script.
 * @param {string} word - The phonetic word.
 * @param {string} language - The target language.
 * @returns {string} - The transliterated word.
 */
function transliterateWord(word, language) {
    const lang = language.toLowerCase();

    if (lang === 'arabic') {
        let result = '';
        let i = 0;
        while (i < word.length) {
            const twoChars = word.substring(i, i + 2).toLowerCase();
            if (arabicMultiMapping[twoChars]) {
                result += arabicMultiMapping[twoChars];
                i += 2;
            } else {
                const char = word[i].toLowerCase();
                result += arabicMapping[char] || char;
                i += 1;
            }
        }
        return result;
    }

    const targetScript = scriptMap[lang];
    if (!targetScript) return word;

    return Sanscript.t(word, 'itrans', targetScript);
}

module.exports = { transliterateWord };
